<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex xs12 class="text-xs-center" mt-5>
                <h1>{{this.$t('welcome_message') + this.$store.state.appTitle}}</h1>
            </v-flex>
            <v-flex xs12 sm6 offset-sm3 class="text-xs-center" mt-5>
                <v-btn color="primary" to="/register">{{this.$t('register_btn_message')}}</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        mounted() {
            if(this.$store.getters.isLogin){
                this.$router.push('/dashboard')
            }
        }
    }
</script>

<i18n>
    {
        "en": {
            "welcome_message": "Welcome to ",
            "register_btn_message": "Register this device"
        },
        "es": {
            "welcome_message": "Bienvenido a ",
            "register_btn_message": "Registrar este dispositivo"
        }
    }
</i18n>